import { debounce } from 'lodash';
import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import { ConferenceRightMenu } from '../../conference/components';
import { toggleChat, closeChat } from '../../chat';
import { toggleParticipantRight } from '../../participant-right';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { VideoTrack } from '../../base/media';
import UserFilm from './UserFilm';
import { ReactNewWindowStyles } from 'react-new-window-styles';
import { Modal } from '../../base/modal';

const NewWindowContainerStyled = styled.div`
    width: 350px; height: 100%; margin: 0;
    display: flex; flex-direction: column; gap: 8px;

    .screen {
        width: 100%;
    }

    .btn {
        display: inline-table;
    }

    .content {
        flex: 1; position: relative; 
        .right_menu {
           width: 100%; 
           .icoImg { display: none; }
        } 
    }

    .btn_group {
        display: flex;
        width: 100%;

        .left, .right { display: inline-flex; }
        .left { margin: 0 auto 0 8px; }
        .right { margin: 0 8px 0 auto; }
    }

    .item:not(.right_menu .item, .mobile .item) {
        width: 100%;
        padding-bottom: 56.25%;
        position: relative;
        overflow: hidden;

        .videoWrap { 
            position: absolute; 
            width: 100%;
            height: 100%;
            video {
                width: 100%;
                height: 100%;
            }
        }
    }

    .mobile {
        display: inline-flex;
        flex-direction: column;
        margin: 0;
        width: 100%;
        height: 100%;
        
        .item { 
            flex-basis: 25%;
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
                
            video {
                background: #000;
                width: 100%;
                height: 100%;
            }
        }

    }

    .namePlate {
        position: absolute;
        width: 100%; height: 5%;
        box-sizing: border-box; bottom: 0;
        background: rgba(0,0,0, 0.7); color:#eee; 
        overflow: hidden; 
        padding: 0 10px; font-size: 12px; 
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        min-height: 25px;
        
        > * {
            margin: 0;
        }
    
        .mike {float: right;}
    }
`;

function ScreenDualFilm({ t, dispatch, screenShare, isParticipantOpen, isChatOpen }) {
    const newWindowNode = useRef();
    const [outerWidth, setOuterWidth] = useState(380);
    const [outerHeight, setOuterHeight] = useState(window.outerHeight);
    const [windowOpen, setWindowOpen] = useState(false);

    const [list, setList] = useState([
        { name: 'videoOn', isOn: !isParticipantOpen && !isChatOpen}, 
        { name: 'chatOn', isOn: isChatOpen },
        { name: 'participantOn', isOn:  isParticipantOpen}
    ]);

    useEffect(() => {
        setWindowOpen(true);
    }, []);

    useEffect(() => {
        if (windowOpen && newWindowNode) {
            const element = newWindowNode.current.state.externalWindow;
            if (element && element.window) {
                element.window.addEventListener('resize', setContainerStyle);
                element.window.addEventListener("visibilitychange", () => element.window.focus());
            }
        } 
    }, [windowOpen]);

    useEffect(() => {
        setList([
            { name: 'videoOn', isOn: !isParticipantOpen && !isChatOpen}, 
            { name: 'chatOn', isOn: isChatOpen },
            { name: 'participantOn', isOn:  isParticipantOpen}
        ]);
    }, [isParticipantOpen, isChatOpen]);

    const setContainerStyle = debounce(e => {    
        e.target.resizeTo(outerWidth, outerHeight);
        e.target.moveTo(0, 0);
    }, 200);

    const open = e => {
        e.addEventListener("resize", setContainerStyle);
        e.addEventListener("visibilitychange", event => {
            e.focus();
        });
    }

    const onClick = value => {
        if (value.name === 'videoOn') {
            if (!value.isOn) {
                dispatch(toggleParticipantRight(false));
                dispatch(closeChat());
            }
        } else if (value.name === 'chatOn') dispatch(toggleChat());
        else if (value.name === 'participantOn') dispatch(toggleParticipantRight(!value.isOn));
    };

    const screenOff = () => {
        APP.mateManagement.toggleScreenShare(false);
    }
    
    return (
        <ReactNewWindowStyles
            ref={newWindowNode}
            title="Meemate2"
            windowProps={{ width: `${outerWidth}`, height: `${outerHeight}px`, left: '0', top: '0' }} 
            onClose={screenOff}
            copyStyles={true}
            autoClose={true}>

            <NewWindowContainerStyled>
                <div className="screen">
                    <div className="item item_false"> 
                        <div className="videoWrap">
                            <VideoTrack videoTrack = { screenShare } />
                        </div>
                    </div>
                </div>
                <div className="nonSelect btn_group">
                    <div className="left">
                        { list.map((value, index) => {
                            const btnOn = value.isOn ? 'btn_on' : '';
                            return (
                                <span key={index} className={`btn btn_true btn_middle ${btnOn}`} onClick={() => {
                                    onClick(value);
                                }}>{t(`layout.${value.name}`)}</span>
                            )
                        }) }
                    </div>
                    <span className="btn btn_true btn_middle right" onClick={screenOff}>{t("layout.stopDocument")}</span>
                </div>
                <div className="content">
                    { isChatOpen || isParticipantOpen ? <ConferenceRightMenu isShow={true} isDualMonitor={true} /> :
                    <div className='mobile'>
                        <UserFilm isDualMonitor={true} isVertical={true} /> 
                    </div> }
                </div>
            </NewWindowContainerStyled>

        </ReactNewWindowStyles>
    )
}

function _mapStateToProps(state) {
    const { isOpen: isChatOpen } = state['features/chat'];
    const { isOpen: isParticipantOpen } = state["features/participant-right"];
    
    return {
        isChatOpen: isChatOpen ? true : false, 
        isParticipantOpen: isParticipantOpen ? true : false
    };
}

export default translate(connect(_mapStateToProps)(ScreenDualFilm));